import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@/components/feedback/Toaster';
import * as usersApi from '../users.api';

export function useUsers() {
  return useQuery({
    queryKey: ['users', 'list'],
    queryFn: usersApi.getUsers,
  });
}

export function useCreateUser() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { addToast } = useToast();

  return useMutation({
    mutationFn: usersApi.createUser,
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      if ((response as { emailSent?: boolean }).emailSent === false) {
        addToast(t('users.toast.createdNoEmail'), 'info');
      } else {
        addToast(t('users.toast.created'), 'success');
      }
    },
  });
}

export function useUpdateUser() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { addToast } = useToast();

  return useMutation({
    mutationFn: ({ userId, data }: { userId: string; data: usersApi.UpdateUserRequest }) =>
      usersApi.updateUser(userId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      addToast(t('users.toast.updated'), 'success');
    },
  });
}

export function useDeactivateUser() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { addToast } = useToast();

  return useMutation({
    mutationFn: usersApi.deactivateUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      addToast(t('users.toast.deactivated'), 'success');
    },
    // Zonder deze regel verdween een geweigerde deactivering geruisloos: het venster klapte dicht
    // en er gebeurde verder niets, dus de beheerder dacht dat het gelukt was.
    onError: () => {
      addToast(t('users.toast.deactivateFailed'), 'error');
    },
  });
}
